<template>
  <div class="panel">
    <Header />
    <PageTitle />
    <div class="page-content">
      <div v-if="currentUser">
        <div class="container-fluid">
          <div class="card">
            <div class="row">
              <div class="col-md-3">
                <Sidebar />
              </div>
              <div class="col-md-9">
                <router-view :key="$route.path"></router-view>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!currentUser">
        <div>
          <router-view></router-view>
        </div>
      </div>
    </div>
    <br />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header"
import PageTitle from "@/components/PageTitle"
import Footer from "@/components/Footer"
import Sidebar from '@/components/Sidebar'

export default {
  name: 'Panel',
  computed: {
    showMenu() {
      return this.$store.state.showMenu
    },
  },
  methods: {
    toggleMenu: function() {
      this.$store.dispatch('toggleMenu')
    }
  },
  components: {
    Header,
    PageTitle,
    Footer,
    Sidebar
  }
}
</script>
